@if (!isLoaded) {
  <lin-spinner></lin-spinner>
}

@if (isLoaded) {
  <form lin-layout-form [formGroup]="userForm" (ngSubmit)="saveData()">
    <lin-layout-form-sections-wrapper>
      <lin-layout-form-section layout="triple">
        @if (currentUser.isClient()) {
          <div class="avatar-wrapper" fxLayoutAlign="center center" [ngClass]="{ disable: isDisabled }">
            <div class="avatar" fxLayoutAlign="center center" [class.disabled]="!isEditMode" (click)="fileAvatar.click()">
              <img [src]="avatar || (user && user.picture ? user.picture : 'assets/images/default_avatar.png')" />
              <input
                hidden
                type="file"
                name="avatar"
                accept="image/png, image/jpeg"
                [disabled]="!isEditMode"
                (change)="uploadAvatar($event.target.files)"
                #fileAvatar
              />
              <span class="upload-image">{{ 'USER.UPLOAD_IMAGE' | translate }}</span>
            </div>
          </div>
        }

        <lin-form-label>{{ 'ADMIN.CLIENTS.USERS.EMAIL' | translate }}:</lin-form-label>
        <mat-form-field>
          <input matInput formControlName="email" autocomplete="off" />
          <mat-error>
            <lin-form-field-error [control]="userForm.get('email')" controlName="email"></lin-form-field-error>
          </mat-error>
        </mat-form-field>

        <lin-form-label required>{{ 'ADMIN.CLIENTS.USERS.NAME' | translate }}:</lin-form-label>
        <mat-form-field>
          <input matInput formControlName="name" autocomplete="off" />
          <mat-error>
            <lin-form-field-error [control]="userForm.get('name')" controlName="name"></lin-form-field-error>
          </mat-error>
        </mat-form-field>

        <lin-form-label required>{{ 'ADMIN.CLIENTS.USERS.SURNAME' | translate }}:</lin-form-label>
        <mat-form-field>
          <input matInput formControlName="surname" autocomplete="off" />
          <mat-error>
            <lin-form-field-error [control]="userForm.get('surname')" controlName="surname"></lin-form-field-error>
          </mat-error>
        </mat-form-field>

        <lin-form-label required>{{ 'FIELDS.PHONE_NUMBER' | translate }}:</lin-form-label>
        <mat-form-field>
          <input matInput formControlName="phone" autocomplete="off" />
          <mat-error>
            <lin-form-field-error [control]="userForm.get('phone')" controlName="phone"></lin-form-field-error>
          </mat-error>
        </mat-form-field>

        <label>{{ 'SETTINGS.TIMEZONE' | translate }}:</label>
        <mat-form-field>
          <lin-form-timezone-select [timezones]="timezones" formControlName="timezone"></lin-form-timezone-select>
          <mat-error>
            <lin-form-field-error [control]="userForm.get('timezone')" controlName="timezone"></lin-form-field-error>
          </mat-error>
        </mat-form-field>
      </lin-layout-form-section>

      <lin-layout-form-section layout="triple">
        <lin-form-label required>{{ 'ADMIN.CLIENTS.USERS.ROLE' | translate }}:</lin-form-label>
        <mat-form-field [class.g-disabled]="isKeyContact">
          <mat-select formControlName="roleId" data-testid="select-role">
            @for (role of roles; track role.id) {
              <mat-option [value]="role.id">{{ role.displayName }}</mat-option>
            }
          </mat-select>
          <mat-error>
            <lin-form-field-error [control]="userForm.get('roleId')" controlName="roleId"></lin-form-field-error>
          </mat-error>
        </mat-form-field>

        <label>{{ 'FIELDS.POSITION' | translate }}:</label>
        <mat-form-field>
          <input matInput formControlName="position" autocomplete="off" />
          <mat-error>
            <lin-form-field-error [control]="userForm.get('position')" controlName="position"></lin-form-field-error>
          </mat-error>
        </mat-form-field>

        <ng-container>
          <label>{{ 'CLIENT.VEHICLES.GROUPS' | translate }}:</label>
          <mat-form-field>
            <mat-select formControlName="groups" multiple data-testid="select-groups">
              @for (group of userGroups; track group.id) {
                <mat-option [value]="group.id">{{ group.name }}</mat-option>
              }
            </mat-select>
            <mat-error>
              <lin-form-field-error [control]="userForm.get('groups')" controlName="groups"></lin-form-field-error>
            </mat-error>
          </mat-form-field>
        </ng-container>

        <lin-language-field formControlName="language"></lin-language-field>

        <label>{{ 'ADMIN.CLIENTS.USERS.STATUS' | translate }}:</label>
        <mat-form-field>
          <input class="status" matInput formControlName="status" [value]="userForm.controls.status?.value | titlecase" />
        </mat-form-field>

        @if (isBlockedMode) {
          <label>{{ 'ADMIN.CLIENTS.USERS.BLOCKING_STATUS' | translate }}:</label>
          <mat-checkbox
            class="form-checkbox block-status"
            [class.block-status-hint]="isKeyContact"
            aria-label="{{ 'ADMIN.CLIENTS.USERS.BLOCKING_STATUS' | translate }}"
            formControlName="isBlocked"
            data-testid="chk-blocking-status"
          >
            {{ 'ADMIN.CLIENTS.USERS.USER_BLOCKED' | translate }}
          </mat-checkbox>
          @if (isKeyContact) {
            <mat-hint>{{ 'ADMIN.CLIENTS.USERS.BLOCKING_KEY_CONTACT' | translate }}</mat-hint>
          }

          @if (userForm.controls.isBlocked.value) {
            <label>{{ 'ADMIN.CLIENTS.USERS.BLOCKING_MESSAGE' | translate }}:</label>
            <mat-form-field>
              <input matInput formControlName="blockingMessage" autocomplete="off" />
              <mat-error>
                <lin-form-field-error [control]="userForm.get('blockingMessage')" controlName="blockingMessage"></lin-form-field-error>
              </mat-error>
            </mat-form-field>
          }
        }
      </lin-layout-form-section>

      <lin-layout-form-section layout="triple">
        @if (canBeDualAccount) {
          <mat-checkbox class="form-checkbox" formControlName="isDualAccount" data-testid="chk-dual-account">
            {{ 'ADMIN.CLIENTS.USERS.DUAL_ACCOUNT' | translate }}
          </mat-checkbox>
        }

        @if (hasDriverFields) {
          <label>{{ 'ADMIN.CLIENTS.USERS.DRIVER_ID' | translate }} {{ 'ADMIN.CLIENTS.USERS.DRIVER_ID_LABEL' | translate }}:</label>
          <mat-form-field>
            <input matInput formControlName="driverId" autocomplete="off" />
            <mat-error>
              <lin-form-field-error [control]="userForm.get('driverId')" controlName="driverId"></lin-form-field-error>
            </mat-error>
          </mat-form-field>

          <lin-form-label>{{ 'FIELDS.DRIVER_SENSOR_ID' | translate }} {{ 'FIELDS.DRIVER_SENSOR_ID_LABEL' | translate }}:</lin-form-label>
          <mat-form-field>
            <input matInput formControlName="driverSensorId" autocomplete="off" />
            <mat-error>
              <lin-form-field-error [control]="userForm.get('driverSensorId')" controlName="driverSensorId"></lin-form-field-error>
            </mat-error>
          </mat-form-field>

          <label>{{ 'ADMIN.CLIENTS.USERS.DRIVER_FOB_ID' | translate }} {{ 'ADMIN.CLIENTS.USERS.DRIVER_FOB_ID_LABEL' | translate }}:</label>
          <mat-form-field>
            <input matInput formControlName="driverFOBId" autocomplete="off" />
            <mat-error>
              <lin-form-field-error [control]="userForm.get('driverFOBId')" controlName="driverFOBId"></lin-form-field-error>
            </mat-error>
          </mat-form-field>

          <lin-form-label>{{ 'ADMIN.CLIENTS.USERS.DEFAULT_TRIP_TYPE' | translate }}:</lin-form-label>
          <mat-form-field>
            <mat-select formControlName="driverRouteScope" data-testid="select-driver-route-scope">
              <mat-option value=""></mat-option>
              @for (scope of DriverRouteScopeLabel | keys; track scope) {
                <mat-option [value]="scope">{{ DriverRouteScopeLabel[scope] | translate }}</mat-option>
              }
            </mat-select>
            <mat-error>
              <lin-form-field-error [control]="userForm.get('driverRouteScope')" controlName="driverRouteScope"></lin-form-field-error>
            </mat-error>
          </mat-form-field>
        }
      </lin-layout-form-section>
    </lin-layout-form-sections-wrapper>

    <lin-layout-form-toolbar>
      <div fxLayout="column">
        <div fxLayout="row">
          @if (!isDisabled) {
            <lin-form-submit-button class="toolbar-button" [isLoading]="isSubmitting" [isDisabled]="!isEditMode" data-testid="btn-save">
              {{ 'BUTTONS.SAVE' | translate }}
            </lin-form-submit-button>

            <button
              class="toolbar-button"
              mat-raised-button=""
              type="button"
              [disabled]="isPasswordResetting || !isResetPasswordMode || isSSOUser"
              color="accent"
              fxLayoutAlign="center center"
              (click)="resetPassword()"
              data-testid="btn-reset-password"
            >
              @if (isPasswordResetting) {
                <mat-progress-spinner [diameter]="26" [strokeWidth]="2" mode="indeterminate" color="accent"></mat-progress-spinner>
              } @else {
                {{ 'BUTTONS.RESET_PASSWORD' | translate }}
              }
            </button>
          }
        </div>
        @if (formError) {
          <div fxLayout="row" class="error-message">
            <div class="lin-form-error">{{ formError }}</div>
          </div>
        }
      </div>

      @if (user) {
        <lin-layout-form-toolbar-info>
          <lin-layout-form-toolbar-info-row>
            <lin-layout-form-toolbar-info-label>{{ 'MAIN.CREATED' | translate }}:</lin-layout-form-toolbar-info-label>
            <lin-layout-form-toolbar-info-value>
              {{ user.createdAt | dayjsDateTime }} {{ user.createdByName && 'USER.BY' | translate }} {{ user.createdByName }}
            </lin-layout-form-toolbar-info-value>
          </lin-layout-form-toolbar-info-row>

          <lin-layout-form-toolbar-info-row>
            <lin-layout-form-toolbar-info-label>{{ 'MAIN.LAST_UPDATED' | translate }}:</lin-layout-form-toolbar-info-label>
            <lin-layout-form-toolbar-info-value>
              {{ (user.updatedAt | dayjsDateTime) || '-' }} {{ user.updatedBy && 'USER.BY' | translate }} {{ user.updatedBy?.fullName }}
            </lin-layout-form-toolbar-info-value>
          </lin-layout-form-toolbar-info-row>

          <lin-layout-form-toolbar-info-row>
            <lin-layout-form-toolbar-info-label>{{ 'MAIN.LAST_LOGIN' | translate }}:</lin-layout-form-toolbar-info-label>
            <lin-layout-form-toolbar-info-value> {{ (user.lastLoggedAt | dayjsDateTime) || '-' }} </lin-layout-form-toolbar-info-value>
          </lin-layout-form-toolbar-info-row>
        </lin-layout-form-toolbar-info>
      }
    </lin-layout-form-toolbar>
  </form>
}
